import { defineStore } from "pinia";

export const useFormStore = defineStore({
  id: "Form",
  state: () => {
    return {
      parentAjaxParamsCorrespondingTable: {},
      openMutationIds: [],
      lastMutationId: 0,
      verdicts: {},
      watchedMutationIds: [],
      mutationTimeouts: {},
    };
  },

  actions: {
    addChildrenToParentAjaxParamsCorrespondingTable(newChildName, value, fieldName) {
      if (!this.parentAjaxParamsCorrespondingTable[newChildName]) {
        this.parentAjaxParamsCorrespondingTable[newChildName] = {};
      }
      this.parentAjaxParamsCorrespondingTable[newChildName][fieldName] = value;
    },

    resetParentAjaxParamsCorrespondingTable() {
      this.parentAjaxParamsCorrespondingTable = {};
    },

    // Suivi des appels mutants (post/put/delete) pour que ModalFormComponent puisse attendre le
    // verdict de l'API avant de se fermer : sans ça la modale disparaît avant l'arrivée des
    // validationErrors Symfony et l'utilisateur perd sa saisie sans voir l'erreur.
    startMutation(timeout = null) {
      this.lastMutationId++;
      const handle = { id: this.lastMutationId };
      this.openMutationIds.push(handle.id);
      if (timeout) {
        this.mutationTimeouts[handle.id] = timeout;
      }
      return handle;
    },

    // `ok` distingue un succès avéré d'un échec : sans ça un 500 ou une erreur mal gérée par le
    // back était indiscernable d'une réussite, et la modale se fermait en perdant la saisie.
    // Seules les mutations suivies par un ModalFormComponent publient un verdict : les autres
    // appels mutants de l'app (auto-save, suppressions…) rempliraient `verdicts` sans fin.
    endMutation(handle, { ok = false, validationErrors = null, reason = null } = {}) {
      if (!handle) {
        return;
      }
      const index = this.openMutationIds.indexOf(handle.id);
      if (index === -1) {
        return;
      }
      this.openMutationIds.splice(index, 1);
      delete this.mutationTimeouts[handle.id];
      if (!this.watchedMutationIds.includes(handle.id)) {
        return;
      }
      this.verdicts[handle.id] = {
        id: handle.id,
        ok: ok,
        validationErrors: validationErrors && validationErrors.length ? validationErrors : null,
        reason: reason,
      };
    },

    watchMutation(id) {
      if (!this.watchedMutationIds.includes(id)) {
        this.watchedMutationIds.push(id);
      }
    },

    releaseMutation(id) {
      const index = this.watchedMutationIds.indexOf(id);
      if (index !== -1) {
        this.watchedMutationIds.splice(index, 1);
      }
      delete this.verdicts[id];
    },

    consumeSubmitVerdict(id) {
      const verdict = this.verdicts[id] ?? null;
      if (verdict) {
        this.releaseMutation(id);
      }
      return verdict;
    },
  },
});
